import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

// Layout
import Layout from '@components/layout/Layout'

// Pages
import HomePage         from '@pages/HomePage'
import AboutPage        from '@pages/AboutPage'
import ProductsPage     from '@pages/ProductsPage'
import ProductDetailPage from '@pages/ProductDetailPage'
import BlogPage         from '@pages/BlogPage'
import BlogPostPage     from '@pages/BlogPostPage'
import ContactPage      from '@pages/ContactPage'
import NotFoundPage     from '@pages/NotFoundPage'
import ComponentShowcase from '@pages/ComponentShowcase'
import ServicesPage        from '@pages/ServicesPage'
import ServiceDetailPage   from '@pages/ServiceDetailPage'
import PrivacyPolicyPage   from '@pages/PrivacyPolicyPage'
import TermsOfUsePage      from '@pages/TermsOfUsePage'
import SitemapPage         from '@pages/SitemapPage'

const PAGE_TITLES = {
  '/':               'Home',
  '/about':          'About Us',
  '/products':       'Products',
  '/blog':           'News & Insights',
  '/contact':        'Contact Us',
  '/services':       'Services',
  '/privacy-policy': 'Privacy Policy',
  '/terms-of-use':   'Terms of Use',
  '/sitemap':        'Sitemap',
}

// ─── Scroll to top + page title on route change ──────────────────────────────
function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })

    const base = 'Salient Agrinutrition'
    const match = Object.keys(PAGE_TITLES)
      .filter(k => k !== '/')
      .find(k => pathname.startsWith(k))
    const label = pathname === '/' ? PAGE_TITLES['/'] : (PAGE_TITLES[match] ?? null)
    document.title = label && pathname !== '/' ? `${label} | ${base}` : base
  }, [pathname])
  return null
}

// ─── App ────────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>

        {/* All pages share the same Navbar + Footer via Layout */}
        <Route path="/" element={<Layout />}>

          {/* ── Main Pages ── */}
          <Route index                   element={<HomePage />} />
          <Route path="about"            element={<AboutPage />} />
          <Route path="contact"          element={<ContactPage />} />

          {/* ── Products ── */}
          <Route path="products"         element={<ProductsPage />} />
          <Route path="products/:slug"   element={<ProductDetailPage />} />

          {/* ── News & Blog ── */}
          <Route path="blog"             element={<BlogPage />} />
          <Route path="blog/:slug"       element={<BlogPostPage />} />

          {/* ── Services ── */}
          <Route path="services"          element={<ServicesPage />} />
          <Route path="services/:slug"    element={<ServiceDetailPage />} />

          {/* ── Legal ── */}
          <Route path="privacy-policy"   element={<PrivacyPolicyPage />} />
          <Route path="terms-of-use"     element={<TermsOfUsePage />} />
          <Route path="sitemap"          element={<SitemapPage />} />

          {/* ── 404 ── */}
          <Route path="*"                element={<NotFoundPage />} />

          {/* ── Component Showcase ── */}
          <Route path="showcase" element={<ComponentShowcase />} />

        </Route>

      </Routes>
    </Router>
  )
}